import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const AdminNavigationLoader: LoadableType<
	{
		className?: string;
	} & {
		children?: any;
	}
> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AdminNavigation" */ '../src/AdminNavigation/index.tsx'
			)
		).AdminNavigation,
});
